SectionProfile.Event.Groupie = Class(
	/**
	 * @lends {SectionProfile.Event.Groupie#}
	 */
	{
		__NAME: 'SectionProfile.Event.Groupie',

		name: 'groupie',

		_draw: function(){
			this._mGetTasks = new DR.crazywolf.GetCompleted();
			this._mGetTasks.select = [
				new DR.roadgames.select.Image().medium().original()
			];
			this.apiCall.addMethod(this._mGetTasks);
		},

		_ready: function() {
			if( !this.event.showResults || !this.event.settings.hasCrazyWolves ){
				Section.navigate(D.url('/profile/event/' + this.event.seoTitle));
				return;
			}
			this._drawSidebar();
			this._drawTabs();

			const re = this._mGetTasks.re;

			mkE({
				tag: 'div',
				className: 'groupie-results',
				els: [
					{
						tag: 'h1',
						text: D.Lang.get('profile.groupie.title')
					},
					{
						tag: 'p',
						text: D.Lang.get('profile.groupie.description')
					},
					this._tasks = mkE({
						tag: 'div',
						className: 'groupie-tasks'
					})
				]
			}).append(this._content);

			for( let i = 0, l = re.tasks.length; i < l; i++ ){
				const task = re.tasks[i];
				mkE({
					tag: 'div',
					className: 'groupie-task groupie-task-' + task.type,
					els: [
						{
							tag: 'a',
							href: task.image ? task.image.original : task.video.url,
							target: '_blank',
							els: [
								{
									tag: 'img',
									src: task.image ? task.image.medium : task.video.thumbnail.medium
								}
							]
						},
						{
							tag: 'div',
							className: 'groupie-text',
							text: task.text
						}
					]
				}).append(this._tasks);
			}
		}
	},
	SectionProfile.EventBase
);
